/* Tysk katalog for locale-autopilot-year-end-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'ap.yearEnd.title': 'Jahresabschluss {{year}}',
  'ap.yearEnd.progress': 'Fortschritt beim Jahresabschluss',
  'ap.yearEnd.step.summary': 'Zusammenfassung',
  'ap.yearEnd.step.review': 'Klärungen',
  'ap.yearEnd.step.additions': 'Ergänzungen',
  'ap.yearEnd.step.final': 'Freigeben',
  'ap.yearEnd.step.submission': 'Einreichung',
  'ap.yearEnd.summaryTitle': 'Ich habe die Jahresgrundlage geprüft',
  'ap.yearEnd.summaryText': 'Du musst nur die Punkte bearbeiten, die sich nicht sicher anhand der Daten in Plumme klären lassen.',
  'ap.yearEnd.approved': 'Geprüft und in Ordnung',
  'ap.yearEnd.notApplicable': 'Nicht zutreffend',
  'ap.yearEnd.needsYou': 'Muss bearbeitet werden',
  'ap.yearEnd.startReview': '{{count}} Punkte bearbeiten',
  'ap.yearEnd.continueAdditions': 'Weiter zu den Ergänzungen',
  'ap.yearEnd.questionCount': '{{total}} Punkte offen',
  'ap.yearEnd.startReviewGroups': '{{count}} Gruppen bearbeiten',
  'ap.yearEnd.groupCount': '{{total}} Gruppen offen',
  'ap.yearEnd.confirmReviewed': 'Ich habe geprüft und bestätige',
  'ap.yearEnd.changeSomething': 'Ich muss etwas ändern',
  'ap.yearEnd.openWorkArea': 'Passenden Arbeitsbereich öffnen',
  'ap.yearEnd.askAboutThis': 'AI dazu fragen',
  'ap.yearEnd.handleCheck': 'Bearbeiten',
  'ap.yearEnd.backToFlow': 'Zurück zum Jahresabschluss',
  'ap.yearEnd.openAsPage': 'Als eigene Seite öffnen',
  'ap.yearEnd.workAreaNote': 'Die Prüfpunkte werden anhand dessen aktualisiert, was du hier tust.',
  'ap.yearEnd.reviewDone': 'Alle Prüfpunkte sind geklärt',
  'ap.yearEnd.reviewDoneText': 'Jetzt prüfen wir, ob du weitere Angaben hast, die nicht in Plumme vorhanden sind.',
  'ap.yearEnd.completeness': 'Vollständigkeitsprüfung',
  'ap.yearEnd.anythingElse': 'Gibt es noch etwas zu ergänzen?',
  'ap.yearEnd.anythingElseText': 'Beschreibe es mit eigenen Worten. AI hilft dir, den richtigen Bereich zu finden, ändert aber nichts, bevor du den Vorschlag geprüft und freigegeben hast.',
  'ap.yearEnd.additionPlaceholder': 'Zum Beispiel: Wir haben im Dezember einen Lieferwagen gekauft, aber die Rechnung kam im Januar.',
  'ap.yearEnd.findAddition': 'Passende Ergänzung finden',
  'ap.yearEnd.showAllAdditions': 'Alle Ergänzungen anzeigen',
  'ap.yearEnd.noMore': 'Nein, ich habe nichts mehr zu ergänzen',
  'ap.yearEnd.finalControl': 'Abschlussprüfung',
  'ap.yearEnd.readyTitle': 'Der Jahresabschluss ist bereit zur Freigabe',
  'ap.yearEnd.result': 'Jahresergebnis',
  'ap.yearEnd.backToReview': 'Offene Punkte bearbeiten',
  'ap.yearEnd.completeAdditions': 'Ergänzungsprüfung abschließen',
  'ap.yearEnd.closeYear': 'Freigeben und Geschäftsjahr abschließen',
  'ap.yearEnd.closing': 'Wird abgeschlossen …',
  'ap.yearEnd.closedToast': 'Das Geschäftsjahr ist abgeschlossen.',
  'ap.yearEnd.saveError': 'Der Jahresabschluss konnte nicht gespeichert werden.',
  'ap.yearEnd.closeError': 'Das Geschäftsjahr konnte nicht abgeschlossen werden.',
  'ap.yearEnd.submissionTitle': 'Das Geschäftsjahr ist abgeschlossen',
  'ap.yearEnd.filedTitle': 'Der Jahresabschluss ist fertig',
  'ap.yearEnd.submissionText': 'Fahre mit der skattemelding und dem Jahresabschluss fort. Spätere Änderungen erfolgen vorerst in der vollständigen Ansicht.',
  'ap.yearEnd.ai.title': 'SuperPlumma fragen',
  'ap.yearEnd.ai.context': 'Das Gespräch bezieht sich auf diesen Jahresabschluss und diesen Prüfpunkt.',
  'ap.yearEnd.ai.empty': 'Frag, warum der Punkt relevant ist, was ein Begriff bedeutet, oder beschreibe etwas, das deiner Meinung nach fehlt.',
  'ap.yearEnd.ai.placeholder': 'Was möchtest du wissen?',
  'ap.yearEnd.ai.ask': 'Fragen',
  'ap.yearEnd.ai.thinking': 'Wird geprüft …',
  'ap.yearEnd.ai.error': 'Die Erklärung konnte gerade nicht abgerufen werden.',
  'ap.yearEnd.ai.noAnswer': 'Ich habe keine sichere Antwort gefunden. Öffne die vollständige Ansicht, um es manuell zu prüfen.',
  'ap.yearEnd.ai.proposalTitle': 'Vorschlag für Steuerposten',
  'ap.yearEnd.ai.assetGroup': 'Abschreibungsgruppe (saldogruppe)',
  'ap.yearEnd.ai.description': 'Beschreibung',
  'ap.yearEnd.ai.openingValue': 'Anfangswert',
  'ap.yearEnd.ai.acquisition': 'Neuanschaffung',
  'ap.yearEnd.ai.improvement': 'Wertsteigernde Aufwendung',
  'ap.yearEnd.ai.proceeds': 'Veräußerungserlös',
  'ap.yearEnd.ai.depreciation': 'Abschreibung',
  'ap.yearEnd.ai.amount': 'Betrag',
  'ap.yearEnd.ai.bookPrevious': 'Buchwert im Vorjahr',
  'ap.yearEnd.ai.taxPrevious': 'Steuerwert im Vorjahr',
  'ap.yearEnd.ai.bookCurrent': 'Buchwert in diesem Jahr',
  'ap.yearEnd.ai.taxCurrent': 'Steuerwert in diesem Jahr',
  'ap.yearEnd.ai.approvalNote': 'Nichts wird gespeichert, bevor du freigibst. Der Posten wird beim Speichern erneut validiert.',
  'ap.yearEnd.ai.approve': 'Freigeben und hinzufügen',
  'ap.yearEnd.ai.saved': 'Der Steuerposten wurde zum Entwurf hinzugefügt. Du kannst weitere Angaben beschreiben, falls noch etwas fehlt.',
  'ap.yearEnd.ai.savedToast': 'Steuerposten hinzugefügt',
  'ap.yearEnd.ai.saveError': 'Der Steuerposten konnte nicht gespeichert werden.',
  'ap.yearEnd.ai.draftInProgress': 'Vorschlag in Bearbeitung',
  'ap.yearEnd.ai.cancelDraft': 'Beenden',
  'ap.agentName.bookkeeping': 'Buchhaltungsagent',
  'ap.agentName.tax': 'Steueragent',
  'ap.agentName.annual': 'Jahresabschlussagent',
  'ap.followup.bank': 'Bankabstimmung',
  'ap.followup.title': 'Nachverfolgung',
  'ap.followup.countOne': '{{count}} Punkt muss nachverfolgt werden.',
  'ap.followup.countMany': '{{count}} Punkte müssen nachverfolgt werden.',
  'ap.agent.tax.titleMissing': '{{count}} Voraussetzungen fehlen noch vor der skattemelding',
  'ap.agent.annual.titleMissing': '{{count}} Voraussetzungen fehlen noch vor dem Jahresabschluss',
  'ap.readiness.yearOpen': 'Das Geschäftsjahr ist nicht abgeschlossen',
  'ap.readiness.yearOpenSub': 'Die Jahresabschlussarbeiten sind nicht durchgeführt',
  'ap.readiness.inbox': '{{count}} Belege sind nicht fertig bearbeitet',
  'ap.readiness.inboxSub': 'Schließe den Posteingang vor der Jahreseinreichung ab',
  'ap.readiness.bank': '{{count}} Bankzeilen sind nicht vollständig abgestimmt',
  'ap.readiness.bankSub': 'Schließe die Bankabstimmung ab',
  'ap.readiness.previousTax': 'Die Abgabe der vorherigen skattemelding ist nicht bestätigt',
  'ap.readiness.reviewYear': '{{year}} prüfen',
  'ap.review.all': 'Alle',
  'ap.review.withVoucher': 'Mit Beleg',
  'ap.review.matched': 'Zugeordnet',
  'ap.review.missingVoucher': 'Beleg fehlt',
  'ap.review.needsChecking': 'Prüfung nötig',
  'ap.review.createsDeviation': 'Verursacht Abweichung',
  'ap.review.upToDate': 'Aktuell',
  'ap.review.approvedNotPosted': 'Freigegeben · nicht gebucht',
  'ap.review.blocked': 'Blockiert',
  'ap.review.ready': 'Bereit',
  'ap.review.yourAccounts': 'Deine Buchhaltung',
  'ap.review.exampleData': 'Beispieldaten',
  'ap.review.voucherLinked': '✓ Beleg verknüpft',
  'ap.review.hideVoucher': 'Beleg ausblenden',
  'ap.review.showVoucher': 'Beleg anzeigen',
  'ap.review.allVouchersLinked': 'Alle Belege sind verknüpft 🎉',
  'ap.review.deadline': 'Frist',
  'ap.review.readyForApproval': 'Bereit zur Freigabe',
  'ap.surface.fullscreen': 'Im Vollbild anzeigen',
  'ap.surface.exitFullscreen': 'Vollbild beenden',
  'ap.surface.voucherCount': '{{count}} Belege',
  'ap.surface.outsideMonth': '{{count}} außerhalb des Monats',
  'ap.surface.accountsAndVouchers': 'Konten und Belege ohne Bankzeile',
  'ap.yearEnd.bank.title': 'Bankabstimmung {{year}}',
  'ap.yearEnd.bank.note': 'Wähle den Monat, der für diesen Jahresabschluss geprüft werden soll.',
  'ap.yearEnd.bank.openLines': '{{count}} offene Bankzeilen',
  'ap.yearEnd.bank.missingStatements': 'Bei {{count}} Bankkonten fehlt der Kontoauszug',
  'ap.yearEnd.bank.done': 'Abgestimmt und archiviert',
  'ap.yearEnd.bank.needsArchive': 'Archivierung prüfen',
  'ap.yearEnd.bank.noStatement': 'Kein Kontoauszug',
  'ap.yearEnd.backToWorkArea': 'Zurück zu {{title}}',
  'ap.surface.bankUploadUnavailable': 'Das Hochladen von Kontoauszügen ist noch nicht verfügbar.',
  'ap.surface.bankReadError': 'Der Kontoauszug konnte nicht gelesen werden.',
  'ap.surface.bankLoadErrorTitle': 'Die Abstimmung konnte nicht geladen werden',
  'ap.surface.bankLoadErrorDetail': 'Lade die Seite neu oder öffne den Kontoauszug über Bank.',
  'ap.surface.assetMovedToExpense': 'Der Beleg wurde aus der Anlagenprüfung entfernt. Prüfe Konto und MwSt. in der Buchungsliste.',
  'ap.surface.assetSkipError': 'Die Anlagenerfassung konnte nicht übersprungen werden.',
  'ap.surface.assetTitle': 'Mögliche Anlagegüter',
  'ap.surface.assetSubtitle': '{{count}} Belege über der Betragsgrenze',
  'ap.surface.assetEmptyTitle': 'Keine Anlagenvorschläge mehr',
  'ap.surface.assetChooseHelp': 'Wähle, ob der Beleg als Anlagegut erfasst oder zurück in die normale Buchungsprüfung geschickt werden soll. Der Kauf wird nur einmal gebucht.',
  'ap.surface.assetNotAsset': 'Kein Anlagegut',
  'ap.surface.inboxTitle': 'Beleg-Posteingang',
});
